(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_carousel-content"] && !Shopify.designMode) return;
  try {
    class CarouselOverflowArrows extends HTMLElement {
    #ro;
    #raf;

    connectedCallback() {
      const scroller = this.querySelector('slideshow-slides');
      const arrows = this.querySelector('slideshow-arrows');

      if (!scroller || !arrows) return;

      const update = () => {
        cancelAnimationFrame(this.#raf);
        this.#raf = requestAnimationFrame(() => {
          arrows.style.display = scroller.scrollWidth <= scroller.offsetWidth + 1 ? 'none' : '';
        });
      };

      this.#ro = new ResizeObserver(() => update('resize'));

      this.#ro.observe(scroller.parentElement ?? this);
      scroller.querySelectorAll('.card').forEach((card) => this.#ro.observe(card));

      // Double rAF so initial layout has fully settled before first check
      requestAnimationFrame(() => requestAnimationFrame(update));
    }

    disconnectedCallback() {
      this.#ro?.disconnect();
      cancelAnimationFrame(this.#raf);
    }
  }

  if (!customElements.get('carousel-overflow-arrows')) {
    customElements.define('carousel-overflow-arrows', CarouselOverflowArrows);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["chat-button"] && !Shopify.designMode) return;
  try {
    class ChatButtonComponent extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.#handleClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.#handleClick);
    }

    #handleClick = () => {
      if (typeof zE !== 'undefined') {
        zE('messenger', 'open');
      }
    }
  }

  customElements.define('chat-button-component', ChatButtonComponent);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["dd-payment-plan-row"] && !Shopify.designMode) return;
  try {
    class DdPaymentPlanRow extends HTMLElement {
    #activeModal = null;

    connectedCallback() {
      this.addEventListener('click', this.#handleClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.#handleClick);
      this.#cleanupModal();
    }

    #handleClick = (event) => {
      const onclickBtn = event.target.closest('[data-onclick-js]');

      if (onclickBtn) {
        event.preventDefault();
        const js = onclickBtn.dataset.onclickJs;
        const price = onclickBtn.dataset.productPrice || '0';

        if (js) {
          try {
            new Function('price', js)(price);
          } catch (err) {
            console.error('Payment plan onclick error:', err);
          }
        }

        return;
      }

      const modalTrigger = event.target.closest('[data-modal-trigger]');

      if (modalTrigger) {
        event.preventDefault();
        this.#openModal(modalTrigger);
        return;
      }

      const closeBtn = event.target.closest('[data-modal-close]');

      if (closeBtn) {
        const dialog = closeBtn.closest('dialog');

        if (dialog instanceof HTMLDialogElement) {
          dialog.close();
        }
      }
    };

    #openModal(trigger) {
      const template = this.querySelector('[data-modal-template]');

      if (!template) return;

      const clone = template.content.cloneNode(true);
      const dialog = clone.querySelector('dialog');

      if (!dialog) return;

      dialog.addEventListener('close', () => this.#cleanupModal(), { once: true });

      dialog.addEventListener('click', (e) => {
        if (e.target === dialog) {
          dialog.close();
        }
      });

      this.appendChild(clone);
      this.#activeModal = dialog;
      dialog.showModal();
    }

    #cleanupModal() {
      if (this.#activeModal) {
        this.#activeModal.remove();
        this.#activeModal = null;
      }
    }
  }

  if (!customElements.get('dd-payment-plan-row')) {
    customElements.define('dd-payment-plan-row', DdPaymentPlanRow);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["dd-promotion-stacks-tiles"] && !Shopify.designMode) return;
  try {
    class DDPromoTiles extends HTMLElement {
    static TILES_PER_SLIDE = 6;

    connectedCallback() {
      this._grid = this.querySelector('.dd-promo-tiles__grid');
      if (!this._grid) return;

      // Store the full flat tile list so we can restore it on resize
      this._allTiles = Array.from(this._grid.children);

      this._buildArrows();

      this._mq = window.matchMedia('(max-width: 749px)');
      this._onBreakpointChange = this._handleBreakpoint.bind(this);
      this._mq.addEventListener('change', this._onBreakpointChange);

      this._handleBreakpoint(this._mq);
    }

    disconnectedCallback() {
      this._mq?.removeEventListener('change', this._onBreakpointChange);
    }

    _handleBreakpoint(e) {
      this._teardown();
      if (e.matches) {
        this._initMobile();
      } else {
        this._initDesktopSlider();
      }
    }

    // ── Desktop ────────────────────────────────────────────────────────────

    _initDesktopSlider() {
      // Desktop only pages through complete groups of 6; excess tiles are discarded here.
      let keptCount = Math.floor(this._allTiles.length / DDPromoTiles.TILES_PER_SLIDE) * DDPromoTiles.TILES_PER_SLIDE;
      if (keptCount === 0) keptCount = this._allTiles.length;
      this._desktopTiles = this._allTiles.slice(0, keptCount);
      this._discardedDesktopTiles = this._allTiles.slice(keptCount);
      this._discardedDesktopTiles.forEach(tile => { tile.style.display = 'none'; });

      if (this._desktopTiles.length <= DDPromoTiles.TILES_PER_SLIDE) {
        this._arrowPrev.classList.add('hidden');
        this._arrowNext.classList.add('hidden');
        this._grid.classList.add('dd-promo-tiles__grid--slider-initialised');
        return;
      }

      // Group flat tiles into slide wrappers of 6
      const slides = [];
      for (let i = 0; i < this._desktopTiles.length; i += DDPromoTiles.TILES_PER_SLIDE) {
        const slide = document.createElement('div');
        slide.className = 'dd-promo-tiles__slide';
        this._desktopTiles.slice(i, i + DDPromoTiles.TILES_PER_SLIDE).forEach(tile => slide.appendChild(tile));
        slides.push(slide);
      }

      this._grid.innerHTML = '';
      this._grid.classList.add('dd-promo-tiles__grid--slider');
      slides.forEach(slide => this._grid.appendChild(slide));
      this._discardedDesktopTiles.forEach(tile => this._grid.appendChild(tile));
      this._desktopSlides = slides;
      this._grid.classList.add('dd-promo-tiles__grid--slider-initialised');

      // Wrap grid in a positioned wrapper for arrow placement
      this._sliderWrapper = document.createElement('div');
      this._sliderWrapper.className = 'dd-promo-tiles__slider-wrapper';
      this._grid.parentNode.insertBefore(this._sliderWrapper, this._grid);
      this._sliderWrapper.appendChild(this._grid);

      this._updateArrows(0, slides.length);
      this._buildDesktopDots(slides);

      this._desktopScrollHandler = this._onDesktopScroll.bind(this);
      this._grid.addEventListener('scroll', this._desktopScrollHandler, { passive: true });
    }

    _buildArrows() {
      const iconPrev = this.querySelector('[data-icon="prev"]').innerHTML;
      const iconNext = this.querySelector('[data-icon="next"]').innerHTML;

      this._arrowPrev = document.createElement('button');
      this._arrowPrev.className = 'dd-promo-tiles__arrow dd-promo-tiles__arrow--prev';
      this._arrowPrev.setAttribute('aria-label', 'Previous slide');
      this._arrowPrev.innerHTML = iconPrev;
      this._arrowPrev.disabled = true;
      this._arrowPrev.addEventListener('click', () => this._step(-1));

      this._arrowNext = document.createElement('button');
      this._arrowNext.className = 'dd-promo-tiles__arrow dd-promo-tiles__arrow--next';
      this._arrowNext.setAttribute('aria-label', 'Next slide');
      this._arrowNext.innerHTML = iconNext;
      this._arrowNext.addEventListener('click', () => this._step(1));

      this.appendChild(this._arrowPrev);
      this.appendChild(this._arrowNext);
    }

    _step(direction) {
      if (this._desktopSlides) {
        const currentIndex = Math.round(this._grid.scrollLeft / this._grid.offsetWidth);
        const nextIndex = Math.max(0, Math.min(this._desktopSlides.length - 1, currentIndex + direction));
        this._grid.scrollTo({ left: this._desktopSlides[nextIndex].offsetLeft, behavior: 'smooth' });
        this._updateDesktopState(nextIndex);
      } else {
        const slideWidth = this._grid.offsetWidth + 16;
        const currentIndex = Math.round(this._grid.scrollLeft / slideWidth);
        const slideCount = this._mobileDots?.length || 1;
        const nextIndex = Math.max(0, Math.min(slideCount - 1, currentIndex + direction));
        this._grid.scrollTo({ left: nextIndex * slideWidth, behavior: 'smooth' });
        this._updateArrows(nextIndex, slideCount);
      }
    }

    _buildDesktopDots(slides) {
      const container = this.querySelector('.dd-promo-tiles__dots--desktop');
      if (!container || slides.length < 2) return;

      container.innerHTML = '';
      slides.forEach((_, i) => {
        const dot = document.createElement('button');
        dot.className = 'dd-promo-tiles__dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
        dot.addEventListener('click', () => {
          this._grid.scrollTo({ left: this._desktopSlides[i].offsetLeft, behavior: 'smooth' });
          this._updateDesktopState(i);
        });
        container.appendChild(dot);
      });

      container.classList.add('is-ready');
      this._desktopDots = Array.from(container.querySelectorAll('.dd-promo-tiles__dot'));
    }

    _onDesktopScroll() {
      if (!this._desktopSlides) return;
      const currentIndex = Math.round(this._grid.scrollLeft / this._grid.offsetWidth);
      this._updateDesktopState(currentIndex);
    }

    _updateDesktopState(index) {
      this._desktopDots?.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
      this._updateArrows(index, this._desktopSlides.length);
    }

    _updateArrows(index, total) {
      if (this._arrowPrev) this._arrowPrev.disabled = index === 0;
      if (this._arrowNext) this._arrowNext.disabled = index === total - 1;
    }

    // ── Mobile ─────────────────────────────────────────────────────────────

    _initMobile() {
      this._mobileDots = Array.from(this.querySelectorAll('.dd-promo-tiles__dots--mobile .dd-promo-tiles__dot'));

      this._mobileDots.forEach((dot, i) => {
        dot.addEventListener('click', () => {
          // Each mobile "slide" is two tiles wide in the grid; gap is 16px
          this._grid.scrollTo({ left: i * (this._grid.offsetWidth + 16), behavior: 'smooth' });
        });
      });

      const slideCount = this._mobileDots.length || 1;
      this._updateArrows(0, slideCount);

      if (this._mobileDots.length > 0) {
        this._mobileScrollHandler = this._onMobileScroll.bind(this);
        this._grid.addEventListener('scroll', this._mobileScrollHandler, { passive: true });
      }

      this._grid.classList.add('dd-promo-tiles__grid--slider-initialised');
    }

    _onMobileScroll() {
      const slideWidth = this._grid.offsetWidth + 16;
      const currentSlide = Math.round(this._grid.scrollLeft / slideWidth);
      this._mobileDots.forEach((dot, i) => dot.classList.toggle('is-active', i === currentSlide));
      this._updateArrows(currentSlide, this._mobileDots.length);
    }

    // ── Teardown ───────────────────────────────────────────────────────────

    _teardown() {
      if (this._arrowPrev) this._arrowPrev.classList.remove('hidden');
      if (this._arrowNext) this._arrowNext.classList.remove('hidden');

      // Remove scroll listeners
      if (this._desktopScrollHandler) {
        this._grid.removeEventListener('scroll', this._desktopScrollHandler);
        this._desktopScrollHandler = null;
      }
      if (this._mobileScrollHandler) {
        this._grid.removeEventListener('scroll', this._mobileScrollHandler);
        this._mobileScrollHandler = null;
      }

      this._grid.classList.remove('dd-promo-tiles__grid--slider-initialised');

      // Unwrap desktop slides back to flat tiles in the grid
      if (this._desktopSlides) {
        this._grid.innerHTML = '';
        this._grid.classList.remove('dd-promo-tiles__grid--slider');
        this._discardedDesktopTiles?.forEach(tile => { tile.style.display = ''; });
        this._allTiles.forEach(tile => this._grid.appendChild(tile));
        this._desktopSlides = null;
        this._desktopDots = null;
        this._discardedDesktopTiles = null;

        // Remove the slider wrapper, moving the grid back out first
        if (this._sliderWrapper) {
          this._sliderWrapper.parentNode.insertBefore(this._grid, this._sliderWrapper);
          this._sliderWrapper.remove();
          this._sliderWrapper = null;
        }

        const desktopDotsContainer = this.querySelector('.dd-promo-tiles__dots--desktop');
        if (desktopDotsContainer) {
          desktopDotsContainer.innerHTML = '';
          desktopDotsContainer.classList.remove('is-ready');
        }
      }

      this._mobileDots = null;
    }
  }

  customElements.define('dd-promo-tiles', DDPromoTiles);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["dd-services-grid-tiles"] && !Shopify.designMode) return;
  try {
    // Splits `n` items (in order) into `k` contiguous groups, minimising the
  // largest group's height as reported by sumFn(start, end). Classic
  // "split array to minimise the largest sum" DP — cheap for the small
  // tile counts a services grid holds.
  function bestSplit(n, k, sumFn) {
    if (k <= 1) return [[0, n]];

    if (k >= n) {
      const groups = [];
      for (let i = 0; i < n; i += 1) groups.push([i, i + 1]);
      while (groups.length < k) groups.push([n, n]);
      return groups;
    }

    const dp = Array.from({ length: k + 1 }, () => new Array(n + 1).fill(Infinity));
    const choice = Array.from({ length: k + 1 }, () => new Array(n + 1).fill(0));
    dp[0][0] = 0;

    for (let j = 1; j <= k; j += 1) {
      for (let i = 1; i <= n; i += 1) {
        for (let m = j - 1; m < i; m += 1) {
          if (dp[j - 1][m] === Infinity) continue;
          const candidate = Math.max(dp[j - 1][m], sumFn(m, i));
          if (candidate < dp[j][i]) {
            dp[j][i] = candidate;
            choice[j][i] = m;
          }
        }
      }
    }

    const groups = [];
    let i = n;
    for (let j = k; j >= 1; j -= 1) {
      const m = choice[j][i];
      groups.unshift([m, i]);
      i = m;
    }
    return groups;
  }

  class DDServicesTiles extends HTMLElement {
    connectedCallback() {
      this._onScroll = this.onScroll.bind(this);
      this._onResize = this.debounce(this.handleResize.bind(this), 150);
      this.dots = this.querySelectorAll('.dd-services-grid__dot');
      this.mq = window.matchMedia('(max-width: 749px)');
      this.tabletMq = window.matchMedia('(max-width: 1023px)');
      this.mq.addEventListener('change', (e) => this.onBreakpointChange(e.matches));
      this.onBreakpointChange(this.mq.matches);

      this._resizeObserver = new ResizeObserver(this._onResize);
      this._resizeObserver.observe(this);
      window.addEventListener('load', this._onResize);
    }

    disconnectedCallback() {
      if (this._resizeObserver) this._resizeObserver.disconnect();
      window.removeEventListener('load', this._onResize);
    }

    debounce(fn, wait) {
      let timeout;
      return (...args) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => fn(...args), wait);
      };
    }

    handleResize() {
      if (this.mq.matches) return;
      this.buildColumns();
    }

    onBreakpointChange(isMobile) {
      if (isMobile) {
        this.teardownColumns();
        this.setupSlider();
      } else {
        this.teardownSlider();
        this.buildColumns();
      }
    }

    getOriginalTiles() {
      const grid = this.querySelector('.dd-services-grid');
      if (!grid) return [];

      if (!this.originalTiles) {
        this.originalTiles = Array.from(grid.children);
      }

      return this.originalTiles;
    }

    teardownColumns() {
      const grid = this.querySelector('.dd-services-grid');
      if (!grid) return;

      const tiles = this.getOriginalTiles();
      grid.classList.remove('is-columns');
      grid.querySelectorAll('.dd-services-grid__column').forEach((column) => column.remove());
      tiles.forEach((tile) => grid.appendChild(tile));
    }

    buildColumns() {
      const grid = this.querySelector('.dd-services-grid');
      if (!grid) return;

      const tiles = this.getOriginalTiles();
      if (!tiles.length) return;

      const columnCount = this.tabletMq.matches
        ? parseInt(grid.dataset.columnsTablet, 10) || 2
        : parseInt(grid.dataset.columnsDesktop, 10) || 3;

      grid.classList.add('is-columns');
      grid.querySelectorAll('.dd-services-grid__column').forEach((column) => column.remove());

      const columns = Array.from({ length: columnCount }, () => {
        const column = document.createElement('div');
        column.className = 'dd-services-grid__column';
        grid.appendChild(column);
        return column;
      });

      // Park every tile in column 0 first so its height is measured at the
      // true final column width (every column already claims an equal share
      // via flex: 1 1 0, regardless of whether it holds children yet).
      tiles.forEach((tile) => columns[0].appendChild(tile));
      const gap = parseFloat(getComputedStyle(columns[0]).rowGap) || 0;
      const tileHeights = tiles.map((tile) => tile.getBoundingClientRect().height);

      // Find the contiguous split into `columnCount` groups (preserving
      // reading order) that minimises the gap between the tallest and
      // shortest column — an exhaustive search over split points, cheap for
      // the small tile counts this grid holds.
      const groupHeight = (start, end) => {
        let sum = gap * (end - start - 1);
        for (let i = start; i < end; i += 1) sum += tileHeights[i];
        return sum;
      };

      const groups = bestSplit(tileHeights.length, columnCount, groupHeight);

      groups.forEach(([start, end], index) => {
        for (let i = start; i < end; i += 1) {
          columns[index].appendChild(tiles[i]);
        }
      });

      // Now that every column is in its final layout, measure each column's
      // own natural height, then fix every column to the tallest one's
      // height. `justify-content: space-between` (set in CSS) spreads that
      // extra space out as additional gap between the cards in that column,
      // instead of leaving it as one blank spacer after the last card.
      columns.forEach((column) => {
        column.style.height = '';
      });

      const columnHeights = columns.map((column) => column.getBoundingClientRect().height);
      const maxHeight = Math.max(...columnHeights);

      columns.forEach((column) => {
        column.style.height = `${maxHeight}px`;
      });

      this._columnCount = columnCount;
    }

    setupSlider() {
      const grid = this.querySelector('.dd-services-grid');
      if (!grid || grid.querySelector('.dd-services-grid__slide')) return;

      const tiles = this.getOriginalTiles();

      for (let i = 0; i < tiles.length; i += 4) {
        const slide = document.createElement('div');
        slide.className = 'dd-services-grid__slide';
        tiles.slice(i, i + 4).forEach((tile) => slide.appendChild(tile));
        grid.appendChild(slide);
      }

      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          const slideWidth = this.grid.offsetWidth + 12;
          this.grid.scrollTo({ left: index * slideWidth, behavior: 'smooth' });
        });
      });

      grid.addEventListener('scroll', this._onScroll, { passive: true });
      this.grid = grid;
    }

    teardownSlider() {
      if (!this.grid) return;

      this.grid.querySelectorAll('.dd-services-grid__slide').forEach((slide) => {
        Array.from(slide.children).forEach((tile) => this.grid.appendChild(tile));
        slide.remove();
      });

      this.grid.removeEventListener('scroll', this._onScroll);
      this.grid = null;
    }

    onScroll() {
      const slideWidth = this.grid.offsetWidth + 12;
      const currentSlide = Math.round(this.grid.scrollLeft / slideWidth);
      this.dots.forEach((dot, index) => {
        dot.classList.toggle('is-active', index === currentSlide);
      });
    }

  }

  customElements.define('dd-services-tiles', DDServicesTiles);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["layout-slider"] && !Shopify.designMode) return;
  try {
    class LayoutSliderComponent extends HTMLElement {
  connectedCallback() {
    this._scroller = this.querySelector('[ref="scroller"]');
    this._dotsContainer = this.querySelector('.layout-slider__dots');
    this._slides = this._scroller ? Array.from(this._scroller.querySelectorAll(':scope > .layout-slide')) : [];

    if (!this._scroller || this._slides.length === 0) return;

    if (this._dotsContainer && this._slides.length > 1) {
      this._buildDots();
      this._observeSlides();
    }

    const prevBtn = this.querySelector('[ref="previous"]');
    const nextBtn = this.querySelector('[ref="next"]');
    if (prevBtn) prevBtn.addEventListener('click', () => this._step(-1));
    if (nextBtn) nextBtn.addEventListener('click', () => this._step(1));

    if (this.dataset.autoplay === 'true') {
      this._startAutoplay();
      if (this.dataset.pauseOnHover === 'true') {
        this.addEventListener('mouseenter', () => this._stopAutoplay());
        this.addEventListener('mouseleave', () => this._startAutoplay());
      }
    }
  }

  _buildDots() {
    this._dotsContainer.innerHTML = '';
    this._slides.forEach((_, i) => {
      const btn = document.createElement('button');
      btn.className = 'layout-slider__dot';
      btn.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
      btn.setAttribute('aria-label', `Go to slide ${i + 1}`);
      btn.addEventListener('click', () => { this._goToSlide(i); this._resetAutoplay(); });
      this._dotsContainer.appendChild(btn);
    });
  }

  _observeSlides() {
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(e => {
          if (e.isIntersecting) {
            const index = this._slides.indexOf(e.target);
            if (index !== -1) this._updateDots(index);
          }
        });
      },
      { root: this._scroller, threshold: 0.5 }
    );
    this._slides.forEach(s => observer.observe(s));
  }

  _goToSlide(index) {
    const slide = this._slides[index];
    if (!slide) return;
    this._scroller.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
    this._updateDots(index);
  }

  _step(direction) {
    const active = this._getActiveIndex();
    const next = (active + direction + this._slides.length) % this._slides.length;
    this._goToSlide(next);
    this._resetAutoplay();
  }

  _getActiveIndex() {
    const scrollLeft = this._scroller.scrollLeft;
    let closest = 0;
    let minDist = Infinity;
    this._slides.forEach((s, i) => {
      const dist = Math.abs(s.offsetLeft - scrollLeft);
      if (dist < minDist) { minDist = dist; closest = i; }
    });
    return closest;
  }

  _updateDots(activeIndex) {
    const dots = this._dotsContainer?.querySelectorAll('.layout-slider__dot');
    dots?.forEach((d, i) => d.setAttribute('aria-selected', i === activeIndex ? 'true' : 'false'));
  }

  _startAutoplay() {
    const interval = parseInt(this.dataset.autoplayInterval) || 5000;
    this._autoplayTimer = setInterval(() => this._step(1), interval);
  }

  _stopAutoplay() {
    clearInterval(this._autoplayTimer);
  }

  _resetAutoplay() {
    if (this.dataset.autoplay === 'true') {
      this._stopAutoplay();
      this._startAutoplay();
    }
  }
}

if (!customElements.get('layout-slider-component')) {
  customElements.define('layout-slider-component', LayoutSliderComponent);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["text-reveal"] && !Shopify.designMode) return;
  try {
    class TextRevealComponent extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.#handleClick, { once: true });
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.#handleClick);
    }

    #handleClick = () => {
      const text = this.dataset.revealedText;
      const textEl = this.querySelector('.text-block');
      if (textEl && text) {
        textEl.innerHTML = text;
        this.classList.add('revealed');
      }
    }
  }

  customElements.define('text-reveal-component', TextRevealComponent);
  } catch(e) { console.error(e); }
})();

})();
